
<template>
    <div class="main-layout" :class="$width===6144?'main-layout2':''" ref="mainLayout">
        <div class="Logo_header" v-if="!isImmersive">{{ $C('common', 'brandTitle', '酪蛋白工厂数字孪生可视化') }}</div>
        <div class="main_content">
            <!-- 内容区 -->
            <keep-alive>
                <Transition name="fade" mode="out-in">
                    <router-view :key="$route.fullPath"></router-view>
                </Transition>
            </keep-alive>
        </div>
        <div v-if="!isImmersive && !['/login','/index'].includes(path)" class="flx-lc backBtn" @click="goBack"><i class="icon-back"></i>{{ $C('common', 'back', '返回') }}</div>
        <ul v-if="!isImmersive && !['/login','/index','/sell','/qula-acquisition'].includes(path)" class="flx-cc bars">
            <li><a class="inter" :class="path.indexOf('international')>-1?'active':''" href="/#/international">{{ $C('common', 'navInternational', '国际市场') }}</a></li>
            <li><a class="china" :class="path.indexOf('china')>-1?'active':''" href="/#/china">{{ $C('common', 'navChina', '国内市场') }}</a></li>
            <li><a class="ganzi"  :class="path.indexOf('ganzi')>-1 || path.indexOf('sell')>-1 || path.indexOf('industry-chain')>-1 || path.indexOf('chain-sub')>-1?'active':''" href="/#/ganzi">{{ $C('common', 'navGanzi', '甘孜市场') }}</a></li>
        </ul>
        <div v-if="!isImmersive && !['/login','/index','/sell'].includes(path)" class="aiBtn" @click="aiClick('open')">{{ $C('common', 'aiBtn', 'AI对话') }}</div>
        <!-- ai弹窗 -->
        <div class="maskbg_ai" v-if="aiShow"></div>
        <div class="aiDialog" v-if="aiShow" :style="aiType==='voice'?{width:'1240px'}:''">
        <div class="tip" :style="aiType==='voice'?{left:'177px',top:'65px'}:''"><span v-if="errorMsg">{{errorMsg}}</span></div>
        <div class="loading" v-loading="connecting" :element-loading-text="loadingText" element-loading-color="#fff" element-loading-background="rgba(0,0,0,0.5)"></div>
        <div v-if="aiType==='text'" class="chat-container" id="chat-container">
            <div class="message" :class="item.type==='ai'?'left':'right'" v-for="(item,index) in message" :key="index">
                <div class="avatar">
                    <img :src="item.type==='ai'?'/assets/ai/photo_ai.png':'/assets/ai/photo_user.png'">
                </div>
                <div class="content">
                    <div class="bubble">{{item.content}}</div>
                </div>
            </div>
        </div>
        <div class="close" @click="aiClick('close')"></div>
        <!-- 主视频（AI 形象视频支持后台替换：素材锚点 --cms-video-ai / --cms-video-ai-speak） -->
        <video class="video" v-show="!isSpeaking" ref="videoDefault" :src="$cmsMedia('--cms-video-ai', '/assets/ai/ai.webm')" autoplay muted loop></video>
        <!-- Speak 视频 -->
        <video class="video" v-show="isSpeaking" ref="videoSpeak" :src="$cmsMedia('--cms-video-ai-speak', '/assets/ai/ai_speak.webm')" autoplay muted loop></video>
        </div>
        <!-- 音频播放 -->
        <audio ref="audioPlayer" @play="onPlayStart" @ended="onPlayEnd"></audio>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                path: '',
                timer: null,
                aiShow: false,
                message: [],
                audioContext: null,
                index: '',
                stream: null,
                websocket: null,
                audioPlayer: null,
                isSpeaking: false,
                audioUrl: null,
                // audioChunks: [],
                // audioDuration: [],
                nextStartTime: 0,
                audioQueue: [], // 存放 { blob } 的队列
                reconnectTimer: null,     // 重连定时器
                reconnectAttempts: 0,     // 重连尝试次数
                maxReconnectAttempts: 5,  // 最大重连次数
                wsConnected: false,       // WebSocket连接状态
                isUserClosed: false,      // 是否是用户主动关闭
      
                isRecording: false,
                startTime: '',
                connecting: false, //ai服务连接
                loadingText: '',
                errorMsg: '',
                aiType: 'text',
            }
        },
        created() {
        },
        mounted() {
        },
        computed: {
            // 沉浸式全屏页：下游客户热力图 / 企业详情页自带头部与返回键，隐藏外壳的标题、返回、导航、AI 按钮，避免重叠
            isImmersive() {
                const p = this.path
                return p === '/downstream-heat' || p.indexOf('/company-detail') === 0
            },
        },
        destroyed() {
            clearInterval(this.timer)
        },
        watch: {
            '$route.path': {
                handler(path){
                    this.path = path
                },
                immediate: true
            }
        },
  methods: {
    // 顶部"返回"：按逻辑层级返回，不再依赖浏览器历史栈（避免乱跳到无关页面）
    goBack() {
      const p = this.path
      if (p === '/ganzi') {
        // 甘孜市场内部 tab：先回到甘孜市场默认视图（再点才回首页），由甘孜组件处理
        this.$root.$emit('ganzi-layout-back')
        return
      }
      // 静态路由精确匹配
      const parentMap = {
        '/sell': '/ganzi',
        '/downstream-heat': '/sell',
        '/industry-chain': '/ganzi',
        '/china': '/index',
        '/international': '/index',
      }
      if (parentMap[p]) { this.$router.push(parentMap[p]); return }
      // 动态路由（带参数）：下级页 → 返回产业链主页面
      if (p.indexOf('/company-detail') === 0) { this.$router.push('/downstream-heat'); return }
      if (p.indexOf('/chain-sub') === 0) { this.$router.push('/industry-chain'); return }
      this.$router.go(-1)
    },
    async aiClick(type){
                if(type === 'open'){
                    this.isUserClosed = false; // 用户打开时重置标志位
                    this.aiShow = true
                    this.connecting = true
                    this.loadingText = '服务连接中'
                    this.message = []
                    this.isRecording = false
                    this.startTime = ''
                    this.errorMsg = ''
                    this.aiType = 'text'
                    await this.initAudioContext();
                    this.initWebSocket()
                }else{
                    this.isUserClosed = true; // 用户主动关闭时设置标志位
                    this.aiShow = false
                    this.connecting = false
                    this.loadingText = ''
                    this.aiType = 'text'
                    this.cleanupAi()
                }
                },
                // 初始化 Web Audio API
                async initAudioContext() {
                try {
                    if (!this.audioContext) {
                    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    }
                    if (this.audioContext.state === 'suspended') {
                    await this.audioContext.resume();
                    }
                    this.nextStartTime = this.audioContext.currentTime;
                    this.audioPlayer = this.$refs.audioPlayer;
                    console.log('音频播放准备就绪')
                } catch (e) {
                    console.error('AudioContext 初始化失败:', e);
                    this.errorMsg = '浏览器不支持Web音频'
                }
            },
            initWebSocket() {
                // 示例：火山引擎实时语音识别 WebSocket 地址（需替换 token/appid 等）
                const url = `${this.$wsUrl}/wss/audio?userId=亚克卓玛`
                this.websocket = new WebSocket(url);
                this.websocket.onopen = () => {
                    console.log('WebSocket 已连接');
                    this.connecting = false;
                    this.loadingText = '';
                    this.wsConnected = true;
                    this.reconnectAttempts = 0;
                    clearTimeout(this.reconnectTimer);
                    if(this.message.length===0){
                    // 播放欢迎词
                    this.textToVoice();
                    }
                };

                this.websocket.onmessage = (event) => {
                    console.log("接收消息");
                    let res = JSON.parse(event.data);
                    console.log(res);
                    if(res.code === 200){
                    if(res.type === 'text_search'){
                        this.connecting = false;
                        this.loadingText = '';
                        this.errorMsg = ''
                        this.aiType = 'text'
                        // 添加h5文字搜索的问题和回答状态
                        this.message.push({
                        content: res.question,
                        type: 'user',
                        index: res.index
                        });
                        this.message.push({
                        content: '努力思考中...',
                        type: 'ai',
                        index: res.index
                        });
                        this.scrollToBottom();
                    }else if(res.type === 'voice'){
                        // 文本大模型结果返回
                        const base64String = res.data;
                        const audioData = atob(base64String); // 将Base64解码为二进制字符串
                        const byteArray = new Uint8Array(audioData.length);
                        for (let i = 0; i < audioData.length; i++) {
                            byteArray[i] = audioData.charCodeAt(i);
                        }
                        const blob = new Blob([byteArray], {type: 'audio/mp3'}); 
                        this.audioUrl = URL.createObjectURL(blob);
                        // 设置到 audio 元素并播放
                        this.audioPlayer.src = this.audioUrl;
                        this.audioPlayer.play();
                        //1-音频，2-文本
                        if(res.flag===2){
                        let obj = this.message.find(it => it.index === res.index && it.type==='ai');
                        if(obj){
                            this.$set(obj,'content',res.answer);
                        }else{
                            this.message.push({
                            content: res.answer,
                            type: 'ai',
                            index: res.index
                            });
                        }
                        this.scrollToBottom();
                        }
                    }else if(res.type === 'connect'){
                        this.aiType = 'voice';
                    }else if(res.type === 'damoxin'){
                        // 语音流大模型结果返回
                        if (res.flag == 1) {
                        this.onVoiceMessage(res)
                        }
                    }
                    }else if(res.code === 600){
                        // 语音对话结束
                        this.errorMsg = '语音对话已结束'
                        this.connecting = false
                    }else{
                    this.errorMsg = res.msg;
                    }
                };

                this.websocket.onerror = (err) => {
                    console.error('WebSocket 错误:', err);
                    this.handleWsError();
                };
                
                this.websocket.onclose = (event) => {
                    console.log('WebSocket 已关闭:', event.code, event.reason);
                    this.wsConnected = false;
                    this.errorMsg = '服务已关闭，正在重连...';
                    this.handleWsClose();
                };
            },
            
            // WebSocket错误处理
            handleWsError() {
                console.error('WebSocket 连接错误');
                this.handleWsClose();
            },
            
            // WebSocket关闭处理
            handleWsClose() {
                // 清理现有连接
                if (this.websocket) {
                    this.websocket.onopen = null;
                    this.websocket.onmessage = null;
                    this.websocket.onerror = null;
                    this.websocket.onclose = null;
                    this.websocket.close();
                    this.websocket = null;
                }
                
                // 如果是用户主动关闭，不再尝试重连
                if (this.isUserClosed) {
                    console.log('用户主动关闭，不进行重连');
                    return;
                }
                
                // 尝试重连
                if (this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.reconnectAttempts++;
                    const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 5000); // 指数退避
                    console.log(`WebSocket 重连尝试 ${this.reconnectAttempts}/${this.maxReconnectAttempts}，延迟 ${delay}ms`);
                    this.reconnectTimer = setTimeout(() => {
                    this.initWebSocket();
                    }, delay);
                } else {
                    this.errorMsg = '服务重连失败，请关闭对话后重试';
                    this.connecting = false;
                }
            },
            // 文字转语音
            textToVoice(){
                console.log("发送文字转语音")
                let data = {
                    type: 'voice',
                    userId: '亚克卓玛',
                    data: '欢迎来到牦牛酪蛋白数智孪生工厂'
                }
                this.websocket.send(JSON.stringify(data))
            },
            onPlayStart() {
                this.isSpeaking = true
                console.log('音频播放开始');
                this.$nextTick(() => {
                    const video = this.$refs.videoSpeak;
                    if (video) {
                    video.play().catch(e => console.log('自动播放失败:', e));
                    }
                });
            },
            onPlayEnd() {
                this.isSpeaking = false
                console.log('音频播放结束');
                this.$nextTick(() => {
                    const video = this.$refs.videoDefault;
                    if (video) {
                    video.play().catch(e => console.log('自动播放失败:', e));
                    }
                });
                // 可选：释放 Blob URL
                if (this.audioUrl) {
                    URL.revokeObjectURL(this.audioUrl);
                    this.audioUrl = null;
                }
            },
            /**
             * desc: base64对象转blob文件对象
             * @param base64  ：数据的base64对象
             * @param fileType  ：文件类型 mp3等;
             * @returns {Blob}：Blob文件对象
             */
            // 接收 WebSocket 消息
            async onVoiceMessage(res) {
                const blob = this.base64ToBlob(res.data, 'wav'); // ✅ 生成 Blob
                const arrayBuffer = await blob.arrayBuffer();
                // 关键：检查是否真的是 ArrayBuffer
                if (!(arrayBuffer instanceof ArrayBuffer)) {
                    console.error('Not an ArrayBuffer!', typeof arrayBuffer);
                    return;
                }
                const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
                if (!audioBuffer) return;
                this.audioQueue.push(audioBuffer);
                if (!this.isSpeaking) {
                    this.isSpeaking = true;
                    this.nextStartTime = this.audioContext.currentTime;
                    this.playNextFromQueue();
                }
            },
            base64ToBlob(base64, fileType = 'wav') {
                // ✅ 正确设置 MIME 类型
                const mimeType = fileType === 'mp3' ? 'audio/mpeg' : 'audio/wav';
                // ✅ 解码 Base64 字符串为二进制
                const byteString = atob(base64); // 注意：base64 必须是纯字符串，无头
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                // ✅ 返回正确类型的 Blob
                return new Blob([ab], { type: mimeType });
            },
            // 无缝播放队列 ===
            playNextFromQueue() {
                if (this.audioQueue.length === 0 || !this.audioContext) {
                    this.isSpeaking = false;
                    this.onPlayEnd();
                    return;
                }

                const audioBuffer = this.audioQueue.shift();
                const source = this.audioContext.createBufferSource();
                source.buffer = audioBuffer;
                source.connect(this.audioContext.destination);

                source.start(this.nextStartTime);
                this.nextStartTime += audioBuffer.duration;

                source.onended = () => {
                    this.playNextFromQueue(); // 自动播下一段
                };
            },
            cleanupAi() {
                // 清理AI资源时，确保不再重连
                this.isUserClosed = true;
                
                // 先清理重连定时器，确保不会有延迟的重连尝试
                if (this.reconnectTimer) {
                    clearTimeout(this.reconnectTimer);
                    this.reconnectTimer = null;
                }
                
                // 关闭WebSocket前先移除事件监听器，避免触发onclose事件导致重复清理
                if (this.websocket) {
                    this.websocket.onopen = null;
                    this.websocket.onmessage = null;
                    this.websocket.onerror = null;
                    this.websocket.onclose = null;
                    this.websocket.close();
                    this.websocket = null;
                }
                
                // 清理其他资源
                if (this.stream) {
                    this.stream.getTracks().forEach(t => t.stop());
                    this.stream = null;
                }
                if (this.audioContext) {
                    this.audioContext.close();
                    this.audioContext = null;
                }
                if (this.audioUrl) {
                    this.audioPlayer.pause();
                    URL.revokeObjectURL(this.audioUrl);
                    this.audioUrl = null;
                }
                if (this.rec) {
                    this.rec.close();
                    this.rec = null;
                }
                
                // 清理数据
                this.audioChunks = [];
                this.audioDuration = [];
                this.res = null;
                this.silentCount = 0;
                this.startTime = '';
                this.isRecording = false;
                this.reconnectAttempts = 0;
                this.wsConnected = false;
            },
            scrollToBottom() {
                this.$nextTick(() => {
                const container = document.getElementById('chat-container');
                container.scrollTop = container.scrollHeight;
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '@/styles/common';
    @import '@/styles/layout/index';
    @import '@/styles/ai';

@keyframes move {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
//进入过程
.fade-enter-active {
    transform-origin: center center;
    animation: move .5s;
}
//离开过程
.fade-leave-active {
    transform-origin: center center;
    animation: move .5s reverse;

}
</style>